import React from 'react';
import List from '@material-ui/core/List';

import routesConfig from '../../../../modules/routesConfig';
import VerticalCollapse from './VerticalCollapse';
import VerticalItem from './VerticalItem';
import VerticalNavGroup from './VerticalNavGroup';
import {
  selectUseNevro,
  selectUseMainstay,
  selectUseCodePull,
  selectIsPortalProClinic,
  selectCampaignOnly,
  selectUseAthena,
  selectUseDrChrono,
  selectUseEClinicalWorks,
  selectUseModMed,
  selectUseAdvancedMD,
  selectUseGreenway,
  selectEnableFoundry,
  selectEnableNoShowPatientFlagging,
} from 'redux/reducers/admin/instance-settings';
import {useSelector} from 'react-redux';

const Navigation = () => {
  const useNevro = useSelector(selectUseNevro);
  const useMainstay = useSelector(selectUseMainstay);
  const useCodePull = useSelector(selectUseCodePull);
  const isPortalProClinic = useSelector(selectIsPortalProClinic);
  const isCampaignOnlyInstance = useSelector(selectCampaignOnly);
  const useModMed = useSelector(selectUseModMed);
  const useAdvancedMD = useSelector(selectUseAdvancedMD);
  const useGreenway = useSelector(selectUseGreenway);
  const useAthena = useSelector(selectUseAthena);
  const useDrChrono = useSelector(selectUseDrChrono);
  const useEClinicalWorks = useSelector(selectUseEClinicalWorks);
  const enableFoundry = useSelector(selectEnableFoundry);
  const enableNoShowPatientFlagging = useSelector(
    selectEnableNoShowPatientFlagging,
  );
  let isParent = false;
  let isChild = false;
  if (localStorage.getItem('isParent')) {
    isParent = localStorage.getItem('isParent') === 'true';
  }
  if (localStorage.getItem('isChild')) {
    isChild = localStorage.getItem('isChild') === 'true';
  }
  let userRole = localStorage.getItem('userRole');
  let isSystemManager = userRole.indexOf('System Manager') > -1;

  let isHFXSite = isParent;
  if (localStorage.getItem('clinicId')) {
    isHFXSite = localStorage.getItem('clinicId') === '';
  }

  const canRenderThisItem = (item) => {
    if (item.requiredEmrEnabled) {
      const hasAnyEmrEnabled =
        useModMed ||
        useAdvancedMD ||
        useGreenway ||
        useAthena ||
        useDrChrono ||
        useEClinicalWorks;
      if (!hasAnyEmrEnabled) {
        return false;
      }
    }

    if (item.id === 'noshowpatients') {
      if (!enableNoShowPatientFlagging) {
        return false;
      }
    }

    // Hide items that require Foundry when Foundry is not enabled
    if (item.requireFoundry && !enableFoundry) {
      return false;
    }

    // If Foundry is enabled for this item, use simple role-based access check
    // bypassing parent/child/Nevro/campaign logic which is not relevant to Foundry
    if (item.requireFoundry && enableFoundry) {
      return item.access.indexOf(userRole) > -1;
    }

    if (!useNevro) {
      if (item.hideOnNevroNotEnabled !== undefined) {
        if (item.hideOnNevroNotEnabled) {
          return false;
        }
      }
    }
    if (
      isPortalProClinic &&
      item.id === 'patientlist' &&
      item.portalpro !== undefined &&
      !item.portalpro
    )
      return false;

    if (item.id === 'auditdashboard') {
      if (isCampaignOnlyInstance || useCodePull) {
        return true;
      } else {
        return false;
      }
    }

    if (
      useCodePull &&
      (item.id === 'patientcampaigns' ||
        item.id === 'contactsupport' ||
        item.id === 'pathways')
    ) {
      if (item.id === 'contactsupport') {
        if (isParent) {
          return false;
        }
        return true;
      }

      if (useNevro && isParent) {
        return false;
      } else if (
        userRole.toLowerCase() === 'doctor' ||
        userRole.toLowerCase() === 'staff'
      ) {
        return false;
      } else {
        if (isParent) {
          return false;
        }
        return true;
      }
    } else if (
      !useCodePull &&
      (item.id == 'patientcampaigns' || item.id === 'contactsupport')
    ) {
      return false;
    }

    if (!isSystemManager && isCampaignOnlyInstance && useCodePull) {
      if (
        item.id === 'patientcampaigns' ||
        item.id === 'contactsupport' ||
        item.id === 'users'
      ) {
        return true;
      } else {
        return false;
      }
    }

    if (isSystemManager && item.hideOnNevroSystemManager) {
      return false;
    }

    if (isSystemManager) {
      return true;
    }

    if (isParent) {
      if (useMainstay) {
        if (item.mainstayParent) {
          return true;
        } else {
          return false;
        }
      }

      if (item.isParent !== undefined) {
        if (item.isParent === isParent && isParent === true) {
          return true;
        }

        return false;
      }
    }

    if (isChild) {
      if (useMainstay) {
        if (item.mainstayChild) {
          return item.access.indexOf(userRole) > -1;
        } else {
          return false;
        }
      }
    }

    if (useNevro) {
      if (item.nevro === undefined) {
        return true;
      }

      return item.nevro === useNevro;
    }

    if (item.access.indexOf(userRole) > -1) {
      return true;
    }

    return false;
  };

  return (
    <List
    // style={{ paddingBottom: 140 }}
    >
      {routesConfig.map((item) => (
        <React.Fragment key={item.id}>
          {item.type === 'group' && canRenderThisItem(item) && (
            <VerticalNavGroup item={item} level={0} />
          )}

          {item.type === 'collapse' && canRenderThisItem(item) && (
            <VerticalCollapse item={item} level={0} />
          )}

          {item.type === 'item' && canRenderThisItem(item) && (
            <VerticalItem item={item} level={0} />
          )}
        </React.Fragment>
      ))}
    </List>
  );
};

export default Navigation;
